import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { countries } from '@material-dev/country-data';

const StateName = ({ stateCode, countryCode }) => (
  <Fragment>
    {
      countries[countryCode] &&
      countries[countryCode].provinces[stateCode] ? countries[countryCode].provinces[stateCode] : stateCode
    }
  </Fragment>
);

StateName.propTypes = {
  stateCode: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  countryCode: PropTypes.string
};

export default StateName;



// WEBPACK FOOTER //
// ./src/app/admin/components/StateName/index.js